import React, { useState, useCallback, useEffect } from 'react';
import { Input, Spin } from 'antd';
import {
  SearchOutlined as searchOutlined
} from '@ant-design/icons';
import { debounce } from 'lodash'
import SearchList from './component/searchList';
import './index.less';
import vmsService from '../vmsService';

const { Search }: { Search: any } = Input;

const SearchOutlined: any = searchOutlined

const searchListRequest = (value) => {
  return vmsService.searchList(value).then((data) => {
    if (data && Array.isArray(data.data)) {
      return data.data
    }
    return []
  })
}

const StarSearch = (props) => {
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const handleRequest = useCallback(debounce((value) => {
    setLoading(true)
    searchListRequest(value).then((data) => {
      setLoading(false)
      setList(data)
    }).catch((err) => {
      setLoading(false)
      setList([])
      console.error(err)
    })
    setShowSearch(true)
  }, 300, { maxWait: 1000 }), [])
  const handleSearch = useCallback((value) => {
    if (list.length) {
      const item = list[0]
      let href = `/star-source/artist/detail?cid=${item.cid}`
      if (item.type === '品牌') {
        href = `/star-source/brand/detail?cid=${item.cid}`
      }
      window.open(href, '_blank')
    } else {
      handleRequest(value)
    }
  }, [list])
  useEffect(() => {
    function blur() {
      setShowSearch(false)
    }
    document.addEventListener('click', blur, false)
    return () => {
      document.removeEventListener('click', blur)
    }
  }, []);
  const handleChange = useCallback((e) => {
    handleRequest(e.target.value)
  }, [])
  const handleFocus = useCallback(() => {
    if (list.length) {
      setShowSearch(true)
    }
  }, [list])

  const stopProp = useCallback((e) => {
    if (e) {
      e.stopPropagation()
      e.preventDefault()
      e.nativeEvent.stopPropagation()
      e.nativeEvent.stopImmediatePropagation()
    }
  }, [])

  return (
    <div className="star-ab-search">
      <div className={`ab-search-block ${showSearch ? 'show' : ''}`} onClick={stopProp}>
        <Search
          // prefix={<SearchOutlined style={{color: '#666F80'}} />}
          placeholder="输入艺人姓名或品牌名称搜索"
          enterButton={<SearchOutlined style={{ color: '#FCB4B0' }} />}
          size="large"
          onChange={handleChange}
          onSearch={handleSearch}
          onFocus={handleFocus}
          onClick={stopProp}
        />
      </div>
      <div className={`search-drop ${showSearch ? 'show' : ''}`}>
        {
          loading ? <div className="loading-block">
            <Spin />
          </div> : <SearchList list={list} />
        }
      </div>
    </div>
  );
};

export default React.memo(StarSearch);
